var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoButtonOutlinedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#2173FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 24H20.8V19.2H19.2V24ZM20 17.6C20.2267 17.6 20.4168 17.5232 20.5704 17.3696C20.724 17.216 20.8005 17.0261 20.8 16.8C20.7995 16.5739 20.7227 16.384 20.5696 16.2304C20.4165 16.0768 20.2267 16 20 16C19.7733 16 19.5835 16.0768 19.4304 16.2304C19.2773 16.384 19.2005 16.5739 19.2 16.8C19.1995 17.0261 19.2763 17.2163 19.4304 17.3704C19.5845 17.5245 19.7744 17.6011 20 17.6ZM20 28C18.8933 28 17.8533 27.7899 16.88 27.3696C15.9067 26.9493 15.06 26.3795 14.34 25.66C13.62 24.9405 13.0501 24.0939 12.6304 23.12C12.2107 22.1461 12.0005 21.1061 12 20C11.9995 18.8939 12.2096 17.8539 12.6304 16.88C13.0512 15.9061 13.6211 15.0595 14.34 14.34C15.0589 13.6205 15.9056 13.0507 16.88 12.6304C17.8544 12.2101 18.8944 12 20 12C21.1056 12 22.1456 12.2101 23.12 12.6304C24.0944 13.0507 24.9411 13.6205 25.66 14.34C26.3789 15.0595 26.9491 15.9061 27.3704 16.88C27.7917 17.8539 28.0016 18.8939 28 20C27.9984 21.1061 27.7883 22.1461 27.3696 23.12C26.9509 24.0939 26.3811 24.9405 25.66 25.66C24.9389 26.3795 24.0923 26.9496 23.12 27.3704C22.1477 27.7912 21.1077 28.0011 20 28ZM20 26.4C21.7867 26.4 23.3 25.78 24.54 24.54C25.78 23.3 26.4 21.7867 26.4 20C26.4 18.2133 25.78 16.7 24.54 15.46C23.3 14.22 21.7867 13.6 20 13.6C18.2133 13.6 16.7 14.22 15.46 15.46C14.22 16.7 13.6 18.2133 13.6 20C13.6 21.7867 14.22 23.3 15.46 24.54C16.7 25.78 18.2133 26.4 20 26.4Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButtonOutlinedActive);
export default __webpack_public_path__ + "static/media/info_button_outlined_active.87c06a12f8e8defd3fbeb120c5e1f3b0.svg";
export { ForwardRef as ReactComponent };